import React, { useEffect, useRef } from "react";
import {
  Filter,
  TextInput,
  RichTextField,
  ShowButton,
  TabbedShowLayout, SimpleShowLayout, Responsive, Query, GET_ONE, Button,
  Tab,
  CardActions,
  Show,
  NumberField,
  List,
  FunctionField,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  DateField,
  BooleanInput,
  Link,
  EditButton,
  DateInput,
  DeleteButton,
} from "react-admin";

import { Grid } from '@material-ui/core/Grid';
import dataProviderFactory from "../dataProvider";
import CreateChargeButton from "../components/createCharge";
import ProfileCompleteMark from "../components/profileCompleteMark";
import { ClientDocumentsIconButton } from "../components/ClientDocumentsModal";
import { documentTarget } from "../utils/agencyRiderDocuments";
import { CustomBaseFilter } from "../components/selectboxfilter/customBaseFilter";
import { TextBooleanField } from "../components/TextBooleanField";
import DeleteButtonWithConfirmation from "../components/DeleteButtonWithConfirmation";

import {
  isEmpty,
  join,
  filter,
  identity,
  map,
  prop,
  compose,
  juxt,
  toUpper,
  head,
  tail,
  sortBy,
  last,
  propEq,
  path,
  isNil
} from "ramda";

import NoBikeAvailableButton from "../components/noBikeAvailableButton";
import { stringify } from "querystring";

import Info from "@material-ui/icons/Info";
import GeneralPopOver from "../components/generalPopOver";
import styled from "styled-components";

import CheckBlackList from "../components/checkBlackList";
import RentalBookingForm from "../components/rentalBookingForm";
import styles from "../components/dashboard/Styles";
import ReactToPrint from 'react-to-print';
import Print from "@material-ui/icons/Print";
import moment from 'moment-timezone';
import { parse } from "date-fns";

import TourBookingFormButton from "../components/tourBookingForm";
import { getPermissionRole } from "../util";
import { getCountryByID } from "../util";
import {
  applyLowSeasonDiscountFor,
  buildRentalPromoSnapshot,
  formatRentalTimeLabel,
} from "../util/rentalPromo";
import {
  resolveBookingInsuranceId,
  insuranceLabel,
  isPaidInsurance,
} from "../util/rentalInsurance";
import RentalCostSummary from "../components/RentalCostSummary";
import { RentalPromoBadges } from "../components/RentalPromoBadges";

moment.tz.setDefault("Europe/Madrid");

const StyledDiv = styled.div((props) => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px",
}));

const ListPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const ViewDetailsButton = (props) => {
  const reditectTo =
    props.record.type === 1 ? "tour_clients" : "rental_clients";
  return (
    <ShowButton
      component={Link}
      to={{
        pathname: `/${reditectTo}/${props.record.id}/show`,
        search: stringify({ from: props.resource }),
      }}
      label="Details"
    ></ShowButton>
  );
};

const getRowColor = (record) => {
  if(record.blacklist) {
    return "#FF6666";
  }
  if (record.rental_status === 3) {
    return "#cccccc";
  }
  if (record.from_agency) {
    return "#FFFF00";
  }

  return "";
};

const rowStyle = (record, index) => ({
  backgroundColor: getRowColor(record),  
});

export const PendingRentalsList = (props) => (
  <List
    {...props}
    title="Pending Rentals"
    resource="pending_rentals"
    bulkActionButtons={false} 
    pagination={false}
    filter={{ type: 2 }}
  >
    <Datagrid rowStyle={rowStyle}>
      <TextField label="Rental ID" source="id" />

      <ReferenceField
        label="Client"
        color="red"
        source="booking_id"
        reference="bookings"
        linkType={false}
      >
        <FunctionField
          render={(booking) =>
            `${booking.r_first_name} ${booking.r_last_name}`
          }
        />
      </ReferenceField>

      <DateField
        label="Pick-up Date"
        source="date_1" locales="es-Es"
        options={{ timeZone: 'Europe/Madrid', year: "numeric", month: "numeric", day: "numeric" }}
      />
      <DateField
        label="Drop-off Date"
        source="date_2" locales="es-Es"
        options={{ timeZone: 'Europe/Madrid', year: "numeric", month: "numeric", day: "numeric" }}
      />

      <ReferenceField
        label="First Choice Bike"
        source="booking.vehicle_model_1"
        reference="vehicle_models"
        linkType={false}
      >
        <TextField source="model_name" />
      </ReferenceField>

      <ReferenceField
        label="Pick-up city"
        source="location_id_1"
        reference="locations"
        linkType={false}
      >
        <FunctionField
          label="Pick-Up City"
          addLabel={false}
          render={(rental) => {
            return (
              <StyledDiv color={rental.color}>
                {rental.location_name}
              </StyledDiv>
            );
          }}
        />
      </ReferenceField>

      <ReferenceField
        label="Drop-off city"
        source="location_id_2"
        reference="locations"
        linkType={false}
      >
        <FunctionField
          label="Drop-off City"
          addLabel={false}
          render={(rental) => {
            return (
              <StyledDiv color={rental.color}>
                {rental.location_name}
              </StyledDiv>
            );
          }}
        />
        {/* <TextField source="location_name" /> */}
      </ReferenceField>

      <TextBooleanField label="From Agency" source="from_agency" />

    {/*   <FunctionField
        label="Promo"
        render={(rental) => {
          const promo = buildRentalPromoSnapshot({
            date_1: rental.date_1,
            time_1: rental.time_1,
            date_2: rental.date_2,
            time_2: rental.time_2,
            from_agency: rental.from_agency,
          });
          return <RentalPromoBadges promo={promo} style={{ marginLeft: 0 }} />;
        }}
      /> */}

      <ReferenceField
        label="Submitted"
        source="booking_id"
        reference="bookings"
        linkType={false}
      >
        <DateField source="r_timestamp" />
      </ReferenceField>

      <ShowButton basePath="pending_rentals" label="Details" />
      <FunctionField
        render={(rental) => {
          if (rental.rental_status === 3) {
            return ("")
          }
          else {
            return (
              <DeleteButtonWithConfirmation basePath="pending_rentals" label="Cancel Booking" resource="pending_rentals" record={rental} />
            );
          }

        }} />

      {/* <DeleteButton basePath="pending_rentals" label="Cancel Booking" /> */}
    </Datagrid>
  </List>
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

const RentalsListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Rental Id" source="id" alwaysOn />
    <CustomBaseFilter label="Pick-up" source="location_id_1" alwaysOn />
    <TextInput label="Client Email" source="client_email" alwaysOn />
    <TextInput label="Client First Name" source="first_name" alwaysOn />
    <TextInput label="Client Last Name" source="last_name" alwaysOn />
    <DateInput label="Pick-up" source="date_begin" locales="es-Es" options={{ timeZone: 'UTC' }} alwaysOn />
    <DateInput label="Drop-off" source="date_end" locales="es-Es" options={{ timeZone: 'UTC' }} alwaysOn />
  </Filter>
);

const RentalsListFilterList = (props) => (
  <Filter {...props}>
    <TextInput label="Rental Id" source="id" alwaysOn />
    <CustomBaseFilter label="Pick-up" source="location_id_1" alwaysOn />
    <TextInput label="Client Email" source="client_email" alwaysOn />
    <TextInput label="Client First Name" source="first_name" alwaysOn />
    <TextInput label="Client Last Name" source="last_name" alwaysOn />
    <DateInput label="Pick-up" source="date_begin" locales="es-Es" options={{ timeZone: 'UTC' }} alwaysOn />
    <DateInput label="Drop-off" source="date_end" locales="es-Es" options={{ timeZone: 'UTC' }} alwaysOn />
    <BooleanInput label="Only paid" source="paid" alwaysOn />
  </Filter>
);

export const RentalsList = ({ permissions, ...props }) => {
  let dayActual = moment(Date.now()).format("YYYY-MM-DD")
  return (
    <List
      {...props}
      title="Booked Rentals"
      resource="rentals"
      bulkActionButtons={false}
      pagination={<ListPagination />}
      sort={{ field: "date_1", order: "ASC" }}
      filterDefaultValues={{ date_begin: Date() }}
      filters={<RentalsListFilterList />}
      filter={{ type: 2, has_totals: 1, show_canceled: 1, show_all: 1 }}
    >
      <Datagrid rowStyle={rowStyle}>
        <TextField label="Rentals ID" source="id" />
        <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} label="Pick-up" source="date_1" />
        <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} label="Drop-off" source="date_2" />
        {/*}
        <ReferenceField
          label="Submitted"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <DateField source="r_timestamp" />
        </ReferenceField>
        {*/}
        <ReferenceField
          label="Model"
          source="main_vehicle_model_id"
          reference="vehicle_models"
          linkType={false}
          allowEmpty
        >
          <TextField source="model_name" />
        </ReferenceField>

        <ReferenceField
          label="Licence Plate"
          source="main_vehicle_id"
          reference="vehicles"
          linkType={false}
          allowEmpty
        >
          <FunctionField
            render={(vehicle) => {
              return (
                <Link
                  to={{ pathname: `/history/${vehicle.id}` }}
                  target="_blank"
                >{`${vehicle.licence_plate} ${vehicle.renting ? "®" : ""}`}</Link>
              );
            }}
          />
        </ReferenceField>
        <FunctionField
          label="Client"
          render={(rental) => {
            const target = documentTarget(rental);
            const booking = rental.booking || {};
            const clientId = booking.client_id || rental.client_id;
            const name = [booking.r_first_name, booking.r_last_name].filter(Boolean).join(" ");
            return (
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                <Link
                  to={{ pathname: `/clients/${clientId}` }}
                  target="_blank"
                >{name}</Link>
                <ClientDocumentsIconButton
                  clientId={target.clientId}
                  rentalId={target.rentalId}
                />
              </span>
            );
          }}
        />

        <ReferenceField
          label="Pick-up"
          source="location_id_1"
          reference="locations"
          linkType={false}
        >
          <FunctionField
            label="Base"
            addLabel={false}
            render={(location) => {
              return (
                <StyledDiv color={location.color}>
                  {location.location_name}
                </StyledDiv>
              );
            }}
          />
        </ReferenceField>

        <ReferenceField
          label="Drop-Off"
          source="location_id_2"
          reference="locations"
          linkType={false}
        >
          <FunctionField
            label="Base"
            addLabel={false}
            render={(location) => {
              return (
                <StyledDiv color={location.color}>
                  {location.location_name}
                </StyledDiv>
              );
            }}
          />
        </ReferenceField>

        <ViewDetailsButton />
        <FunctionField
          addLabel={false}
          render={(rental) => {
            return (
              <RentalBookingForm bookingId={rental.booking_id} rental={rental} />
            );
          }}
        />

        <FunctionField
          addLabel={false}
          render={(rental) => {
          /*   if (moment(rental.date_2).diff(dayActual, "days") >= 0) { */
              if (!isEmpty(rental.payments)) {
                const pendingCharges = filter(
                  propEq("status", false),
                  prop("charges", head(rental.payments))
                );
                if (isEmpty(pendingCharges)) {
                  if (
                    rental.rental_status !== 3 &&
                      // prop("isAdmin", permissions)) || prop("isManager", permissions) || 
                      [1, 2, 3, 4, 9].includes(getPermissionRole())
                  ) {
                    return (
                      <React.Fragment>
                        <EditButton
                          to={{
                            pathname: `/process_rental_edit/${rental.id}`,
                            search: '?from=rentals'
                          }}
                          search={stringify({ from: props.resource })}
                          record={rental}
                          label="Edit"
                        />
                        <DeleteButton
                          redirect="rentals"
                          basePath="rentals"
                          resource="rentals"
                          label="Cancel"
                          record={rental}
                          disabled={rental.rental_status === 3 ? true : false}
                          undoable={false}
                        />
                      </React.Fragment>
                    );
                  }
                } else {
                  return (
                    <GeneralPopOver
                      itemText="Pending Charges. Please Reload List. For more info check Details - Payments"
                      iconImage={Info}
                    />
                  );
                }
              }
            /* } else {
              return "";
            } */
          }}
        />

        <FunctionField
          addLabel={false}
          render={(rental) => <ProfileCompleteMark record={rental} />}
        />

        {/* {(prop("isAdmin", permissions) || prop("isManager", permissions)) && ( */}
        {[1, 2, 3, 4, 9].includes(getPermissionRole()) && (
          <FunctionField
            addLabel={false}
            render={(rental) => {
              if (rental.rental_status !== 3) {
                return (
                  <CreateChargeButton rental={rental} extraCharge={true} />
                );
              }
              return "";
            }}
          />
        )}
      </Datagrid>
    </List>
  );
};

export const RentalsDueList = (props) => {
  return (
    <List
      {...props}
      title="Rentals Due"
      resource="rentals_due"
      filters={<RentalsListFilter />}
      sort={{ field: "date_1", order: "ASC" }}
      filterDefaultValues={{ date_begin: null }}
      bulkActionButtons={false}
      pagination={false}
      filter={{ type: 2 }}
    >
      <Datagrid rowStyle={rowStyle}>
        <TextField label="Rental ID" source="id" />
        <TextField label="Client" source="client_name" />
        <FunctionField
          label="Days to rental"
          source="days_to_event"
          render={(rental) => {
            return `${rental.days_to_event} days`;
          }}
        />

        <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} label="Pick-up" source="date_1" />

        <FunctionField
          label="Pick-Up City"
          addLabel={false}
          render={(rental) => {
            return (
              <StyledDiv color={rental.color_1}>
                {rental.location_name_1}
              </StyledDiv>
            );
          }}
        />

        <DateField locales="es-Es" options={{ timeZone: 'Europe/Madrid' }} label="Drop-off " source="date_2" />
        <FunctionField
          label="Drop-Off City"
          addLabel={false}
          render={(rental) => {
            return (
              <StyledDiv color={rental.color_2}>
                {rental.location_name_2}
              </StyledDiv>
            );
          }}
        />

        <ReferenceField
          label="Submitted"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <DateField source="r_timestamp" />
        </ReferenceField>
       {/*  <FunctionField
          label="Billable days"
          render={(rental) => {
            if (rental.billable_days == null || rental.billable_days === '') {
              return '—';
            }
            const weekend =
              Number(rental.billable_days) === 2 &&
              Number(rental.included_km) === 700;
            return weekend
              ? `${rental.billable_days} (weekend)`
              : `${rental.billable_days}`;
          }}
        /> */}
        <NumberField
          source="rental_price"
          options={{
            maximumFractionDigits: 2,
            style: "currency",
            currency: "EUR",
          }}
        />
        <NumberField
          label="Total Paid"
          source="total_payed"
          options={{
            maximumFractionDigits: 2,
            style: "currency",
            currency: "EUR",
          }}
        />
       {/*  <NumberField
          source="due"
          options={{
            maximumFractionDigits: 2,
            style: "currency",
            currency: "EUR",
          }}
        /> */}
        <FunctionField
          label="Due" 
          render={(rental) => {
            return (
              <StyledDiv>
                { parseFloat(parseFloat(rental.due, 2) - parseFloat(rental.discount, 2)).toFixed(2) } €	
              </StyledDiv>
            );
          }}
        />

        <FunctionField
          addLabel={false}
          render={(rental) => {
            return (
              <CreateChargeButton
                rental={rental}
                extraCharge={false}
                history={props}
              />
            );
          }}
        />
        <ViewDetailsButton />
      </Datagrid>
    </List>
  );
};

const cardActionStyle = {
  zIndex: 2,
 //display: "inline-block",
  float: "right",
};

const PendingRentalShowActions = ({ basePath, data, resource }) => {
  let booking
  if(data!= undefined)
   booking = data.booking_id
  else 
    booking = 0
  return (
  <CardActions style={cardActionStyle}>
    <RentalBookingForm bookingId={booking} rental={data} />
    <ProfileCompleteMark
      record={data}
      rentalId={data && data.id}
      clientId={data && data.client_id}
    />
    <EditButton basePath="/process_rental" record={data} label="Process" />
    {/*<NoBikeAvailableButton record={data} />*/}
  </CardActions>
)};

const duration = (date1, time1, date2, time2) => {
  const days = moment(date2).diff(date1, "days");
  if (time1 === "10:00:00" && time2 === "18:00:00") {
    return days + 1;
  } else if (time1 === "18:00:00" && time2 === "10:00:00") {
    return days - 1;
  }
  return days;
};

const resolveMotoDays = rental => {
  const promo = buildRentalPromoSnapshot({
    date_1: rental.date_1,
    time_1: rental.time_1,
    date_2: rental.date_2,
    time_2: rental.time_2,
    from_agency: rental.from_agency,
  });
  return promo;
};

let array = []
async function getModels(id, key) {
  const dataProvider = await dataProviderFactory("rest");
  const models = await dataProvider(GET_ONE, "vehicle_models", { id })
  //console.log(models)
  array.push(models.data)
  if (key === 1)
    document.getElementById('model1').innerHTML = `${models.data.model_name} (first choice)`
  if (key === 2)
    document.getElementById('model2').innerHTML = ` - ${models.data.model_name} (second choice)`
  let newrowLocation = JSON.stringify(models)
  let objetoLocation = JSON.parse(newrowLocation);
  return objetoLocation;
}
async function getCountry(id, key) {
  const dataProvider = await dataProviderFactory("rest");
  const models = await dataProvider(GET_ONE, "countries", { id })
  //console.log(models)
  array.push(models.data)
  if (key === 1) {
    const countryElement = document.getElementById('countryD');
    if (countryElement) {
      countryElement.innerHTML = `${models.data.country}`;
    }
  }
  if (key === 2) {
    if(typeof(id) !== "number"){
        const nationalityElement = document.getElementById('nationalityD');
        if (nationalityElement) {
          nationalityElement.innerHTML = `${id}`;
        }
      return id;  
    }
    else{  
      document.getElementById('nationalityD').innerHTML = `${models.data.country}`
    }
  }
  let newrowLocation = JSON.stringify(models)
  let objetoLocation = JSON.parse(newrowLocation);
  return objetoLocation;
}

function GetRefe(rental) {
  const ref = rental.driver.referral
  return ref;
}

function DiasFaltante(date1) {
  let fecha1 = Date.now()
  let fecha2 = Date.now(date1)
  let diff = fecha2 - fecha1;
  //let days = moment(fecha2).diff(fecha1, 'days')  
  console.log(diff)
  return diff;
};

const componentRef = React.createRef();

export const PendingRentalShow = (props) => (
  <Show
    {...props}
    actions={<PendingRentalShowActions {...props} />}
    title="Motorcycle Rental Edit"
  >
    <SimpleShowLayout>
      <ReactToPrint
        trigger={() => (
          <Button color="primary" label="Print">
            <Print />
          </Button>
        )}
        content={() => componentRef.current}
      />
      <FunctionField id="react-no-print" ref={componentRef}
        label=" "
        render={(rental) => {
          return DetalleRental(rental);
        }}
      />
    </SimpleShowLayout>
  </Show>
);

const DetalleRental = (rental) => (
  <React.Fragment>
    <Responsive
      medium={
        <div class="fullwith" style={styles.flexPadding}> <hr />
          <div style={styles.flex}>
            <h3 class="colorTitleP">RENTAL BOOKING FORM ({`${rental.id}`})</h3>
          </div>
          <div id="padreForm" style={styles.flex}>
            <div style={styles.leftCol}>
              <div class="minusPadd" style={styles.flexB}>
                <h2 class="colorTitle">Rental summary</h2>
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  id="Pick-up"
                  label="Pick-up"
                  render={(d) => {
                    const location = rental.location_1.location_name;
                    const date = moment(rental.date_1);
                    const time = formatRentalTimeLabel(rental.time_1);
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Pick-up: </label>
                      <span class="tamDetalle2">{`${location} on ${date.format("dddd")} ${time}, ${date.format("MMMM D, YYYY")}`}</span>
                    </React.Fragment>
                  }}
                />
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  label="Drop-off"
                  render={(d) => {
                    const location = rental.location_2.location_name;
                    const date = moment(rental.date_2);
                    const time = formatRentalTimeLabel(rental.time_2);
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Drop-off: </label>
                      <span class="tamDetalle2">{`${location} on ${date.format("dddd")} ${time}, ${date.format("MMMM D, YYYY")}`}</span>
                    </React.Fragment>
                  }}
                />
              </div>
              <br />
              <div style={styles.flexB}>
                <FunctionField
                  label="Rental Duration"
                  render={(d) => {
                    const promo = resolveMotoDays(rental);
                    return (
                      <React.Fragment>
                        <label class="colorDetalle tamDetalle">Duration: </label>
                        <span class="tamDetalle2">
                          {`${promo.occupancy_days} days · Billable: ${promo.moto_days} days`}
                          <RentalPromoBadges promo={promo} />
                        </span>
                      </React.Fragment>
                    );
                  }}
                />
              </div>  <br />
              <div style={styles.flexB}>
                <FunctionField
                  label="First Choice Bike"
                  render={(d) => {
                    getModels(rental.booking.vehicle_model_1, 1)
                    getModels(rental.booking.vehicle_model_2, 2)
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Motorcycle: </label>
                      <span id="model1" class="boldDetalle tamDetalle2">{` `} </span>
                      <span class="tamDetalle2" id="model2">{` `}</span>
                      {/*  <span class="boldDetalle"> (first choice) </span> */}
                    </React.Fragment>
                  }}
                />
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  label="Second Choice Bike"
                  render={(d) => {

                    return <React.Fragment>
                      <label>  </label>

                      {/* <span class="tamDetalle2"> (second  choice)</span> */}
                    </React.Fragment>
                  }}
                />
              </div>  <br />
              <div style={styles.flexB}>
                <FunctionField
                  label="Daily Rate for First Choice Motorcycle"
                  render={(d) => {
                    const price = head(
                      filter(
                        propEq("price_item_type", "vehicle_model"),
                        rental.booking.prices
                      )
                    ).price;
                    //return `${price} euros/day`;
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Daily rate for first choice motorcycle: </label>
                      <span class="tamDetalle2">{`${price} euros/day`}</span>
                    </React.Fragment>
                  }}
                />
              </div>
              <div style={styles.flexB}>
                <FunctionField
                  label="Daily Rate for Second Choice Motorcycle"
                  render={(d) => {
                    const numbOfDays = resolveMotoDays(rental).moto_days;
                    const intervalPrices = filter(
                      (price) =>
                        price.days_interval_1 <= numbOfDays &&
                        price.days_interval_2 >= numbOfDays,
                      rental.booking.secondChoicePrices
                    );
                    const sortedIntervalPrices = sortBy(
                      compose(moment, prop("start_date")),
                      intervalPrices
                    );
                    //return `${last(sortedIntervalPrices).price} euros/day`;
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Daily rate for second choice motorcycle: </label>
                      <span class="tamDetalle2">{`${last(sortedIntervalPrices).price} euros/day`}</span>
                    </React.Fragment>
                  }}
                />
              </div> <br />
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="GPS"
                          render={(d) => {
                            if (!rental.booking.r_gps) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">GPS: </label> <span class="tamDetalle2">No    </span>
                              </React.Fragment>
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">GPS: </label> <span class="tamDetalle2">Yes    </span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="One Way"
                          render={(d) => {
                            if (rental.location_id_1 === rental.location_id_2) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">One way: </label> <span class="tamDetalle2">No</span>
                              </React.Fragment>
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">One way: </label> <span class="tamDetalle2">Yes</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="VIP Insurance"
                          render={(d) => {
                            const insId = resolveBookingInsuranceId(rental.booking);
                            const label = insuranceLabel(insId);
                            if (!isPaidInsurance(insId)) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">Insurance: </label> <span class="tamDetalle2">Regular</span>
                              </React.Fragment>
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Insurance: </label> <span class="tamDetalle2">{label}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div> <br />
                  </div><br />
                </div>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Rewards Used"
                          render={(d) => {
                            return <React.Fragment>
                              <label class="colorTitle">IMT rewards: </label> <span class="tamDetalle2">{`${rental.booking.rewards} points`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="From Agency"
                          render={(d) => {
                            if (!rental.from_agency) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">From agency: </label> <span class="tamDetalle2">No</span>
                              </React.Fragment>
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">From agency: </label> <span class="tamDetalle2">Yes</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Agency Name"
                          render={(d) => {
                            if (rental.agency_name != null) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">Agency name: </label>
                                <span class="tamDetalle2">{`${rental.agency_name}`}</span>
                              </React.Fragment>
                            }
                          }}
                        />
                      </div> <br />
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Agency Contact"
                          render={(d) => {
                            if (rental.agency_contact != null) {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">Agency contact: </label>
                                <span class="tamDetalle2">{`${rental.agency_contact}`}</span>
                              </React.Fragment>
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={styles.rightCol}>

              <div class="minusPadd" style={styles.flexB}>
                <h2 class="colorTitle">Rider info:</h2>
              </div>
              <div style={styles.flexB} >
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Rider"
                          render={(d) => (
                            <React.Fragment>
                              <label class="colorDetalle tamDetalle">Name: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_first_name} ${rental.booking.r_last_name}`}</span>
                              <ShowButton
                                label="View Client"
                                component={Link}
                                to={{ pathname: `/clients/${rental.driver.id}` }}
                                target="_blank"
                              />
                            </React.Fragment>
                          )}
                        />
                      </div>
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Email"
                          render={(b) => {
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Email: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_email}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div><br />
              <div style={styles.flexB}>
                <FunctionField
                  label="Allergy/Special Diet"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Allergy/Special Diet: </label>
                      <span class="tamDetalle2">{`${rental.booking.r_allergy_special_diet || ''}`}</span>
                    </React.Fragment>
                  }}
                />
              </div><br />
              <div style={styles.flexB}>
              <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                        <div style={styles.flexB}>
                          <FunctionField
                            label="Phone Number"
                            render={(b) => {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle"> Phone number: </label>
                                <span class="tamDetalle2"> Home {`${rental.booking.r_home_phone}`}  - </span>
                                <span class="tamDetalle2"> Work {`${rental.booking.r_work_phone}`}</span>
                              </React.Fragment>
                            }}
                          />
                        </div>
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                            label="Nickname"
                            render={(b) => {
                              return <React.Fragment>
                                <label class="colorDetalle tamDetalle">Nickname: </label>
                                <span id="tourDate1" class="boldDetalle tamDetalle2">{`${ rental.booking.nickname != null ? rental.booking.nickname : ''}`} </span>
                              </React.Fragment>
                            }}
                          />
                      </div>
                    </div>
                  </div>
                </div> 
              </div>  <br />
              <div style={styles.flexB} >
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Address"
                          render={(b) => {
                            const state = isNil(rental.booking.r_state_province) ? "" : `${rental.booking.r_state_province}`
                            getCountry(rental.booking.r_country_id, 1)
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Address: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_address} ${rental.booking.r_zip}, ${rental.booking.r_city}, ${state} `}</span>
                              <span class="tamDetalle2" id="countryD">{``}</span>
                            </React.Fragment>

                          }}
                        />
                      </div> <br />
                      {/* <div style={styles.flexB}>
                        <FunctionField
                          label="Country"
                          render={(b) => {
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Country: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_country_id}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br /> */}
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Nationality"
                          render={(b) => {
                            console.log(rental)
                            getCountry(rental.booking.r_nationality, 2)
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Nationality: </label>
                              <span id="nationalityD" class="tamDetalle2">{``}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Passport/ID"
                          render={(b) => {
                            const passport = isNil(rental.booking.r_passport) ? "N/A" : `${rental.booking.r_passport}`
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Passport/ID: </label>
                              <span class="tamDetalle2">{`${passport}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Driver's License"
                          render={(b) => {
                            const licen = isNil(rental.booking.r_license) ? "N/A" : `${rental.booking.r_license}`
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Driver's license: </label>
                              <span class="tamDetalle2">{`${licen}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> <br />
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Occupation"
                          render={(b) => {
                            const ocupation = isNil(rental.booking.r_occupation)
                              ? "N/A"
                              : `${rental.booking.r_occupation}`
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Occupation: </label>
                              <span class="tamDetalle2">{`${ocupation}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Languages Spoken"
                          render={(b) => {
                            const capitalize = compose(
                              join(""),
                              juxt([compose(toUpper, head), tail])
                            );
                            const languages = [
                              "english",
                              "spanish",
                              "german",
                              "french",
                              "portuguese",
                            ];
                            const lang = join(
                              ", ",
                              filter(
                                identity,
                                map((language) => {
                                  return prop(`r_${language}`, rental.booking)
                                    ? capitalize(language)
                                    : false;
                                }, languages)
                              )
                            );
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Languages spoken: </label>
                              <span class="tamDetalle2">{`${lang}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftColB}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Date of Birth"
                          render={(b) => {
                            const birtday = isNil(rental.booking.r_birthday) ? "N/A" : `${rental.booking.r_birthday}`
                            const fortmat = moment(birtday).format("DD-MM-YYYY")
                            const anio = moment().diff(moment(rental.booking.r_birthday), "years")

                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Date of birth: </label>
                              <span class="tamDetalle2">{`${fortmat} --> ${anio} years`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Height"
                          render={(b) => {
                            const unit = rental.booking.r_height_unit === 1 || rental.booking.r_height_unit === '1'?  "ft" : "m";
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle" >Height: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_height} ${unit}`}</span>
                            </React.Fragment>
                            //return `${rental.booking.r_height} ${unit}`;
                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Weight"
                          render={(b) => {
                            const unit = rental.booking.r_weight_unit === 1 || rental.booking.r_weight_unit === '1'? "lbs" : "kg";
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Weight: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_weight} ${unit}`}</span>
                            </React.Fragment>
                            //return `${rental.booking.r_weight} ${unit}`;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={styles.flex}>
            <div style={styles.leftCol}>
              <div class="minusPadd" style={styles.flexB}>
                <h2 class="colorTitle">Rental cost:</h2>
              </div>
              <div style={styles.flexB}>
                <RentalCostSummary rental={rental} />
              </div> <br />
              <div style={styles.flexB}>
                <FunctionField
                  label="Credit card"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Credit card: </label>
                      <span class="tamDetalle2">{`${rental.clientData}`}</span>
                    </React.Fragment>
                  }}
                />
              </div> <br />
            </div>
            <div style={styles.rightCol}>
              <div class="minusPadd" style={styles.flexB}>
                <h2 class="colorTitle">Riding experience</h2>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Years of Riding"
                          render={b => {
                            const experienceYears = parseInt(rental.booking.r_experience_years, 10);
                            let experienceYearsNumber = 0;
                            if (!Number.isNaN(experienceYears)) {
                              experienceYearsNumber = experienceYears.toString().length === 4 ? (new Date().getFullYear()) - experienceYears : experienceYears
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Years of riding: </label>
                              <span class="tamDetalle2">{`${experienceYearsNumber} years`}</span>
                            </React.Fragment>
                            //return `${experienceYearsNumber} years`;
                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Riding Last Year"
                          render={(b) => {
                            const unit =
                              rental.booking.r_experience_past_year_unit === 1 ? "km" : "miles";
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Riding last year: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_experience_past_year} ${unit}`}</span>
                            </React.Fragment>
                            //return `${rental.booking.r_experience_past_year} ${unit}`;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Average Ride Distance"
                          render={(b) => {
                            const unit =
                              rental.booking.r_experience_ride_distance_unit === 1
                                ? "km"
                                : "miles";
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Average ride distance: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_experience_ride_distance} ${unit}`}</span>
                            </React.Fragment>
                            //return `${rental.booking.r_experience_ride_distance} ${unit}`;
                          }}
                        />
                      </div> <br />
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Riding Experience"
                          render={(b) => {
                            const capitalize = compose(
                              join(""),
                              juxt([compose(toUpper, head), tail])
                            );
                            const exp = ["street", "sweepers", "twisties", "track", "off_road"];
                            const data = join(
                              ", ",
                              filter(
                                identity,
                                map((exp) => {
                                  return prop(`r_${exp}`, rental.booking)
                                    ? capitalize(exp)
                                    : false;
                                }, exp)
                              )
                            );
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Riding experience: </label>
                              <span class="tamDetalle2">{`${data}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div> <br />
                    </div>
                  </div>
                </div>
              </div>
              <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="Motorcycle(s) Owned"
                          render={(b) => {
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">Motorcycle(s) owned: </label>
                              <span class="tamDetalle2">{`${rental.booking.r_own_models}`}</span>
                            </React.Fragment>
                          }}
                        />
                      </div>
                    </div>
                    <div style={styles.rightCol}>
                      <div style={styles.flexB}>
                        <FunctionField
                          label="How did you find about us?"
                          render={(b) => {
                            const refer = GetRefe(rental)
                            let d = ''
                            if (refer != undefined) {
                              d = refer.name
                              // path(["driver", "referral", "name"], rental)
                            }
                            return <React.Fragment>
                              <label class="colorDetalle tamDetalle">How did you find about us?: </label>
                              <span class="tamDetalle2">{`${d}`}</span>
                            </React.Fragment>
                            //return path(["driver", "referral", "name"], rental);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={styles.flex}>
            <div style={styles.leftCol}>
              <div class="minusPadd" style={styles.flexB}>
                <h2 class="colorTitle">Emergency contact</h2>
              </div>
              {/* <div style={styles.flexB}>
                <div style={styles.flexPaddingI}>
                  <div style={styles.flex}>
                    <div style={styles.leftCol}> */}
              <div style={styles.flexB}>
                <FunctionField
                  label="Name"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Name: </label>
                      <span class="tamDetalle2">{`${rental.booking.r_emergency_name}`}</span>
                    </React.Fragment>
                  }}
                />
              </div>
              {/*  </div>
                    <div style={styles.leftCol}> */}
              <div style={styles.flexB}>
                <FunctionField
                  label="Relationship"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Relationship: </label>
                      <span class="tamDetalle2">{`${rental.booking.r_emergency_relationship}`}</span>
                    </React.Fragment>
                  }}
                />
              </div>
              {/*  </div> 
                    <div style={styles.leftCol}> */}
              <div style={styles.flexB}>
                <FunctionField
                  label="Phone Number"
                  render={(b) => {
                    return <React.Fragment>
                      <label class="colorDetalle tamDetalle">Phone number: </label>
                      <span class="tamDetalle2">{`${rental.booking.r_emergency_phone}`}</span>
                    </React.Fragment>
                  }}
                />
              </div>
              {/*  </div> 
                  </div>
                </div>
              </div>  */}
            </div>
          </div>
        </div>
      } />
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/resources/rentals.js